"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const hooks_1 = require("@alfalab/hooks");
const error_1 = require("../../error");
const use_composite_context_1 = require("../../provider/hooks/use-composite-context");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * <SidePanel.Error>
 *
 * Обработка типовых ошибок для SidePanel.
 */
const Error = ({ dataTestId, errorType, onError, isWebView }) => {
    const [mobile] = (0, hooks_1.useMedia)([[true, '(max-width: 1023px)']], false);
    const compositeContext = (0, use_composite_context_1.useCompositeContext)();
    const props = {
        onClick: onError,
        className: (0, classnames_1.default)(index_module_css_1.default.component, { [index_module_css_1.default.desktop]: !mobile }),
        dataTestId,
        fullHeight: mobile,
        type: (errorType === 'NETWORK' ? 'NETWORK' : 'INTERNAL'),
        isWebView,
        iconBackgroundColor: `var(--${compositeContext.appId}-color-light-neutral-translucent-100)`,
    };
    return (0, jsx_runtime_1.jsx)(error_1.Error, Object.assign({}, props));
};
exports.Error = Error;
